import BaseModel from './BaseModel';

class RentalBooking extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.created_at = data.created_at;
    this.lease_offer_amount = data.lease_offer?.emi_amount
    this.swap_done = data.swaps_count;
    this.swap_credited = data.customer_lease_offer?.swap_credit_on_emi_payment;
    this.bike = data.bike?.name;
    this.vehicle = data.selected_vehicle?.serial_number;
    this.battery = data.battery?.serial_number;
    this.service_center = `${data.service_center?.name} | Opens at ${data.service_center?.open_time} | Closes at ${data.service_center?.close_time}`
    this.booking = `Started on ${data.start_date} | Ends on ${data.end_date}` 
    if(data.rolled_over_credits > 0 ) {
      this.rolled_over_swaps = data.customer_lease_offer?.rolled_over_credits
    }
    if(data.over_due_days > 0 ) {
      this.over_due_days = data.over_due_days
    }
  }
}

export default RentalBooking;
